import React, { useState } from 'react';
import styled from 'styled-components';
import { useDispatch } from 'react-redux';
import { populateAnalysisThunk } from '../../redux/slices/analyses';
import { IS_LOCALHOST } from '../../config/constants';
import toastMessage from '../../utils/toastMessage';
import { LayoutMainContainer } from '../../Layout/LayoutUI';
import { ChartMode } from '../../components/Chart/types';
import { Chart } from '../../components/Chart';

const Submit = styled.div`
  border: 1px solid black;
  width: fit-content;
  padding: 2px 6px;
  cursor: pointer;
  margin-bottom: 36px;
`;
export default () => {
  const dispatch = useDispatch();
  const [input, setInput] = useState('');
  const [currAnalysisId, setCurrAnalysisId] = useState('');
  if (!IS_LOCALHOST) {
    // if not in local develop env, redirect to origin url directly
    window.location.href = window.location.origin;
  }
  const onSubmitHandler = () => {
    let res: any = {};
    try {
      res = JSON.parse(input);
    } catch (e) {
      toastMessage({ message: 'not valid json input.', type: 'error' });
      return;
    }
    const data = res.data.analysis;
    dispatch(populateAnalysisThunk({ analysis: data }));
    console.info('Analysis Data:', data);
    setCurrAnalysisId(data.id);
  };

  return (
    <LayoutMainContainer>
      <form>
        <label>Paste the analysis response here.</label>
        <div style={{ marginBottom: '12px' }} />
        <textarea
          value={input}
          onChange={(event: any) => setInput(event.target.value)}
          rows={10}
          cols={100}
        />
      </form>
      <Submit onClick={() => onSubmitHandler()}>Execute</Submit>

      {currAnalysisId && (
        <div style={{ height: '400px' }}>
          <Chart analysisId={currAnalysisId} mode={ChartMode.View} />
        </div>
      )}
    </LayoutMainContainer>
  );
};
